import {DataTableSortStatus} from 'mantine-datatable';
import {BindingDriftReportSummary} from '../types';

export const moduleConfig = {
    entityKey: 'binding-drift-reconciliation',
    basePath: '/binding-drift-reconciliation',
    titles: {
        singular: 'Binding Drift Report',
        plural: 'Binding Drift Reconciliation'
    }
}

// Newest run first, on runStartedAt: AWSDateTime! — non-null and immutable (it is
// the idempotency anchor inside the id), and the API already returns this order
// (recordType-runStartedAt-index, scanIndexForward: false), so the first paint
// agrees with the server instead of reshuffling it.
export const defaultSortStatus: DataTableSortStatus<BindingDriftReportSummary> = {
    columnAccessor: 'runStartedAt',
    direction: 'desc',
};
